import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useEffect, useState} from 'react'
import jwt_decode from "jwt-decode";
import { Form, Input ,Select } from 'antd';
import {ButtonBase} from '@mui/material';
import config from '../../config'
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
import { useLocation, useNavigate } from 'react-router-dom';
const { Option } = Select;

export default function EditUser() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const location = useLocation();
  const {id: uid} = location.state;

  const navigate = useNavigate()

  const onFinish = async ({phNum: ph,fullName: fname,password: psw,maxDailyLimit}) => {
    setLoading(true)
    const params ={uid,ph,fname,psw,maxDailyLimit}

    const data = await axios.put(`/member/updateMemberInfos`,params)
    setErrorMsg({ code: data.code, msg: data.message })
    setLoading(false)
    setOpenAlert(true)
    if(data.code == 200){
      navigate(-1)
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        padding: 1rem;
        margin: 0 10rem;
      `}
    >
        {/* <h2 style={{fontWeight: 'normal',marginBottom: "2rem"}}>Edit User</h2> */}
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <Form
        name="basic"
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upper />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
  );
}

const Upper = () =>{
  const location = useLocation();
  const {username,full_name,commission,phone_number,timezone,created_at,limit_daily_max_bet_amount_per_user: maxDailyLimit} = location.state;
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };
  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="username"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={username}
        >
          <Input  size="large" disabled  />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Full Name"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="fullName"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={full_name}
        >
          <Input  size="large" />
        </Form.Item>
     
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Phone Number"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="phNum"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={phone_number}
        >
          <Input
          type='number'
          onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}   
          size="large" 
          />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="password"
          hasFeedback
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              min: 6,
              max: 15,
              message: "Password must be between 5 and 13 words!",
            },
          ]}
        >
          <Input.Password
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
          />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
         <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Max Daily Limit"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="maxDailyLimit"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={maxDailyLimit}
          rules={[
            {
              required: true,
              message: `Please input password!`,
            }
          ]}
        >
          <Input size="large" />
        </Form.Item>
      </div>
  
    </div>
  );
}